import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { ColumnBib, ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


function VvoPlayerStatsScore({ data, team, currPeriod, periods }) {
  const style = {
    backgroundColor: 'ForestGreen',
  };

  const styleSub = {
    border: '2px solid #ccc',
    display: 'inline-block',
    paddingLeft: '5px',
    paddingRight: '5px'
  }

  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;

  const tableColumns = useMemo(() =>
    [
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Bib',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderBib',
        columns: [
          ColumnBib({ disableSort: true, label: 'HeaderShirtNo', expecialCase: true, remove: true }),
        ]
      },
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Name',
        headerClassName: "text-start align-middle",
        id: 'HeaderName',
        columns: [
          ColumnNameH2H({ showStarter: false, remove: true }),
        ]
      },
      {
        id: 'HeaderSets',
        Header: <Label data="HeaderSets" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsSet1',
            Header: '1',
            headerClassName: "text-center",
            className: 'text-center w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let result
              if (findArray(props.cell.row.original.extResults, { er_code: ['SET_PLAYED'], er_pos: ['S1'] }).er_value === 'Y')
                result = <div style={style}>&nbsp;</div>
              if (findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S1'] }).er_value !== undefined)
                result = <div style={styleSub}>{findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S1'] }).er_value}</div>
              if (findArray(props.cell.row.original.extResults, { er_code: ['LIBERO'], er_pos: ['S1'] }).er_value === 'Y')
                result = <div>L</div>
              return result
            }
          },
          {
            id: 'PlayerStatsSet2',
            Header: '2',
            headerClassName: "text-center",
            className: 'text-center w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              if (currPeriod === 'S2' || currPeriod === 'S3' || currPeriod === 'S4' || currPeriod === 'S5' || currPeriod === 'TOT') {
                let result
                if (findArray(props.cell.row.original.extResults, { er_code: ['SET_PLAYED'], er_pos: ['S2'] }).er_value === 'Y')
                  result = <div style={style}>&nbsp;</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S2'] }).er_value !== undefined)
                  result = <div style={styleSub}>{findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S2'] }).er_value}</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['LIBERO'], er_pos: ['S2'] }).er_value === 'Y')
                  result = <div>L</div>
                return result
              }
              else return ''
            }
          },
          {
            id: 'PlayerStatsSet3',
            Header: '3',
            headerClassName: "text-center",
            className: 'text-center w-5',
            isVisible: false,
            columnIndex: 3,
            Cell: (props) => {
              if (currPeriod === 'S3' || currPeriod === 'S4' || currPeriod === 'S5' || currPeriod === 'TOT') {
                let result
                if (findArray(props.cell.row.original.extResults, { er_code: ['SET_PLAYED'], er_pos: ['S3'] }).er_value === 'Y')
                  result = <div style={style}>&nbsp;</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S3'] }).er_value !== undefined)
                  result = <div style={styleSub}>{findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S3'] }).er_value}</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['LIBERO'], er_pos: ['S3'] }).er_value === 'Y')
                  result = <div>L</div>
                return result
              }
              else return ''
            }
          },
          {
            id: 'PlayerStatsSet4',
            Header: '4',
            headerClassName: "text-center",
            className: 'text-center w-5',
            isVisible: false,
            columnIndex: 4,
            Cell: (props) => {
              if (currPeriod === 'S4' || currPeriod === 'S5' || currPeriod === 'TOT') {
                let result
                if (findArray(props.cell.row.original.extResults, { er_code: ['SET_PLAYED'], er_pos: ['S4'] }).er_value === 'Y')
                  result = <div style={style}>&nbsp;</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S4'] }).er_value !== undefined)
                  result = <div style={styleSub}>{findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S4'] }).er_value}</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['LIBERO'], er_pos: ['S4'] }).er_value === 'Y')
                  result = <div>L</div>
                return result
              }
              else return ''
            }
          },
          {
            id: 'PlayerStatsSet5',
            Header: '5',
            headerClassName: "text-center",
            className: 'text-center w-5',
            isVisible: false,
            columnIndex: 5,
            Cell: (props) => {
              if (currPeriod === 'S5' || currPeriod === 'TOT') {
                let result
                if (findArray(props.cell.row.original.extResults, { er_code: ['SET_PLAYED'], er_pos: ['S5'] }).er_value === 'Y')
                  result = <div style={style}>&nbsp;</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S5'] }).er_value !== undefined)
                  result = <div style={styleSub}>{findArray(props.cell.row.original.extResults, { er_code: ['SUBSTITUTE'], er_pos: ['S5'] }).er_value}</div>
                if (findArray(props.cell.row.original.extResults, { er_code: ['LIBERO'], er_pos: ['S5'] }).er_value === 'Y')
                  result = <div>L</div>
                return result
              } else return ''
            }
          },
        ]
      },
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsPoints',
        headerClassName: "text-center w-5 align-middle",
        id: 'HeaderStatsPoints',
        columns: [
          {
            id: 'PlayerStatsPoints',
            Header: <Label data="HeaderPoints" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 6,
            remove: true,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SCR'], pos: [currPeriod] }).value;
              return value

            }
          }
        ]
      },
      {
        id: 'HeaderAttack',
        Header: <Label data="HeaderAttack" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsAtkPtsTotal',
            Header: <Label data="HeaderPoints/Total" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 7,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPK'], pos: [currPeriod] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPK'], pos: [currPeriod] }).attempt;
              return <PlayerStatsType1 value={value} attempt={attempt} />
            }
          },
          {
            id: 'PlayerStatsAtkEff',
            Header: <Label data="HeaderEff" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 8,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPK'], pos: [currPeriod] }).percent;
              return value
            }
          }
        ]
      },
      {
        id: 'HeaderBlock',
        Header: <Label data="HeaderBlock" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsBlock',
            Header: <Label data="HeaderPoints/Total" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 9,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['BLC'], pos: [currPeriod] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['BLC'], pos: [currPeriod] }).attempt;
              return <PlayerStatsType1 value={value} attempt={attempt} />
            }
          },
          {
            id: 'PlayerStatsBlockAvg',
            Header: <Label data="HeaderAvgBySet" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 10,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['BLC'], pos: [currPeriod] }).avg;
              return value
            }
          },
        ]
      },
      {
        id: 'HeaderService',
        Header: <Label data="HeaderService" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsService',
            Header: <Label data="HeaderPoints/Total" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 11,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SRV'], pos: [currPeriod] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SRV'], pos: [currPeriod] }).attempt;
              return <PlayerStatsType1 value={value} attempt={attempt} />
            }
          },
          {
            id: 'PlayerStatsServeAvg',
            Header: <Label data="HeaderAvgBySet" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 12,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SRV'], pos: [currPeriod] }).avg;
              return value
            }
          },
        ]
      },
    ], []
  )
  const tableColumnsSM = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo', expecialCase: true }),
      ColumnNameH2H({ showStarter: false, hideNoc: true }),
      {
        id: 'PlayerStatsPoints',
        Header: <Label data="HeaderPTS" />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['SCR'], pos: [currPeriod] }).value;
          return value

        }
      },
      {
        id: 'PlayerStatsAtk',
        Header: <Label data="HeaderAttack" />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['SPK'], pos: [currPeriod] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPK'], pos: [currPeriod] }).attempt;
          return <PlayerStatsType1 value={value} attempt={attempt} />
        }
      },
      {
        id: 'PlayerStatsBlock',
        Header: <Label data="HeaderBlock" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['BLC'], pos: [currPeriod] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['BLC'], pos: [currPeriod] }).attempt;
          return <PlayerStatsType1 value={value} attempt={attempt} />
        }
      },
      {
        id: 'PlayerStatsService',
        Header: <Label data="HeaderService" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['SRV'], pos: [currPeriod] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['SRV'], pos: [currPeriod] }).attempt;
          return <PlayerStatsType1 value={value} attempt={attempt} />
        }
      },
    ], []
  )

  let _caption = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />

  const { breakPoint } = useViewport();
  let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns

  let hiddenColumns = []
  if (findArray(periods, { p_code: ['S4'] }).p_code !== 'S4') {
    hiddenColumns.push('PlayerStatsSet4')
  }
  if (findArray(periods, { p_code: ['S5'] }).p_code !== 'S5') {
    hiddenColumns.push('PlayerStatsSet5')
  }

  return (
    <>{ }
      {athletes &&
        <MirsTable
          id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
          caption={_caption}
          data={athletes}
          columns={columns}
          hiddenColumns={hiddenColumns}
          keyRow={"athlete-code"}
          initialSortBy={[{ id: 'Bib', desc: false }]}
          colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '7' : '7'}
          showNavExtendedData={false}
          colIndex={1}
        />
      }
    </>
  );
}

export default VvoPlayerStatsScore;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}

function PlayerStatsType1({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}


